import React, { useState } from "react"
import { Form, Modal, Select, message as antdMessage } from "antd"
import InputField from "../Common/InputField"
import "../../styles/Components/inputfields.css"
import "../../styles/Components/adduser.css"
import { translations } from "../../utils/Translation/staticTranslation"

const UserModalStructure = ({
  isModalOpen,
  handleCancel,
  title,
  subtitle,
  buttonText,
  onFinish,
  isEmailDisabled = false,
  form,
  roleOptions = [
    { value: "admin", label: "Admin" },
    { value: "viewer", label: "Viewer" },
  ],
  initialValues = {},
  isSubmitting = false,
}) => {
  const lang = localStorage.getItem("language") || "ar"
  const AddUserModal = translations[lang]?.userPage?.ad_user_modal
  const [emailValue, setEmailValue] = useState("")

  const handleEmailChange = (e) => {
    const value = e.target.value.toLowerCase()
    setEmailValue(value)

    if (value.includes("+")) {
      antdMessage.error(
        lang === "ar"
          ? 'لا يمكن أن يحتوي البريد الإلكتروني على "+"'
          : "Email cannot contain '+'"
      )
      return
    }

    form.setFieldsValue({ email: value })
  }

  return (
    <Modal
      title={title}
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
    >
      <p className="mb-28">{subtitle}</p>
      <Form onFinish={onFinish} form={form} initialValues={initialValues}>
        <InputField
          className="login-field custom-placeholder"
          name="email"
          type="email"
          placeholder={AddUserModal?.email_placeholder}
          disabled={isEmailDisabled}
          onChange={handleEmailChange}
          inputProps={{ style: { textTransform: "lowercase" } }}
          rules={[
            {
              required: true,
              message: AddUserModal?.email_error_1,
            },
            {
              type: "email",
              message: AddUserModal?.email_error_2,
            },
            {
              validator: (_, value) =>
                value && value.includes("+")
                  ? Promise.reject(
                      lang === "ar"
                        ? 'لا يمكن أن يحتوي البريد الإلكتروني على "+"'
                        : "Email cannot contain '+'"
                    )
                  : Promise.resolve(),
            },
          ]}
        />

        <Form.Item
          className="error-input-fix"
          name="role"
          rules={[
            {
              required: true,
              message: AddUserModal?.role_error,
            },
          ]}
        >
          <Select
            placeholder={AddUserModal?.role_placeholder}
            className="add-user-select"
            options={roleOptions}
          />
        </Form.Item>

        <button
          className="border-radius-255 login-btn mt-24"
          disabled={emailValue?.includes("+") || isSubmitting}
        >
          {buttonText}
        </button>
      </Form>
    </Modal>
  )
}

export default UserModalStructure
